import React from 'react';
import { CloseIcon } from './Icons';
import '../App.css';

const ErrorModal = ({ isOpen, onClose, title = '错误', message, type = 'error' }) => {
  if (!isOpen) return null;

  const getErrorIcon = () => {
    switch (type) {
      case 'duplicate':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17V7m0 10L6 14m3 3l3-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 7v10m0-10l3 3m-3-3l-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'permission':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.5 10.5C19.5 17 12 22 12 22C12 22 4.5 17 4.5 10.5C4.5 6.35786 7.85786 3 12 3C16.1421 3 19.5 6.35786 19.5 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'network':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1l22 22M9 9v3a3 3 0 003 3v0a3 3 0 003-3V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 12a9 9 0 11-18 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      default:
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M15 9l-6 6m0-6l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
    }
  };

  const getErrorTypeText = () => {
    switch (type) {
      case 'duplicate':
        return '重复内容错误';
      case 'permission':
        return '权限错误';
      case 'network':
        return '网络连接错误';
      default:
        return '系统错误';
    }
  };

  const getErrorSuggestions = () => {
    switch (type) {
      case 'duplicate':
        return [
          '检查文章标题是否重复',
          '检查URL别名是否唯一',
          '尝试修改标题或URL别名后重新提交'
        ];
      case 'permission':
        return [
          '确认您已登录正确的账户',
          '检查您的账户是否具备作者权限',
          '如需权限帮助，请联系系统管理员'
        ];
      case 'network':
        return [
          '检查您的网络连接是否正常',
          '稍后重试操作',
          '如果问题持续存在，请联系技术支持'
        ];
      default:
        return [
          '请检查输入信息是否正确',
          '稍后重试操作',
          '如问题仍未解决，请联系技术支持'
        ];
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="error-modal" onClick={e => e.stopPropagation()}>
        <div className="error-modal-header">
          <div className="error-modal-icon">
            {getErrorIcon()}
          </div>
          <div className="error-modal-title">
            <h3>{title}</h3>
            <p className="error-type">{getErrorTypeText()}</p>
          </div>
          <button className="modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="error-modal-body">
          <div className="error-message">
            {message}
          </div>

          <div className="error-suggestions">
            <h4>建议解决方案：</h4>
            <ul>
              {getErrorSuggestions().map((suggestion, index) => (
                <li key={index}>{suggestion}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="error-modal-footer">
          <button className="btn-primary" onClick={onClose}>
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;